<template>
  <!-- 资金tab页 -->
  <div id="transcc_new_tab_myAssetsNew">
    <div v-for="(row, i) in tableData" :key="`transcc_new_tab_myAssetsNew-row-${i}`" class="as_row">
      <div v-for="(item, j) in row" :key="`transcc_new_tab_myAssetsNew-item-${j}`" :style="`order:${item.order}`" class="as_col">
        <div class="as_col_n">{{ item.n }}</div>
        <div class="as_col_v">{{ item.v }}{{ item.unit }}</div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol */
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      tableData: [
        [
          { n: '当前可用资金', v: '--', unit: '', order: '' },
          { n: '当前余额', v: '--', unit: '', order: '' },
          { n: '当前权益', v: '--', unit: '', order: '' }
        ],
        [
          { n: '划入资金', v: '--', unit: '', order: '' },
          { n: '期初余额', v: '--', unit: '', order: '' },
          { n: '期初权益', v: '--', unit: '', order: '' }
        ],
        [
          { n: '划出资金', v: '--', unit: '', order: '' },
          { n: '风险率', v: '--', unit: '%', order: '' },
          { n: '挂单冻结资金', v: '--', unit: '', order: '' }
        ],
        [
          { n: '转让盈亏', v: '--', unit: '', order: '' },
          { n: '货值变化', v: '--', unit: '', order: '' },
          // { n: '上日订金', v: '--', unit: '', order: '' },
          // { n: '有效货值变化', v: '--', unit: '', order: '' }
          { n: '当日交收手续费', v: '--', unit: '', order: '' },
        ],
        [
          { n: '当日订金', v: '--', unit: '', order: '' },
          { n: '交收担保金', v: '--', unit: '', order: '' },
          { n: '货款收入', v: '--', unit: '', order: '' }
          // { n: '上日有效货值变化', v: '--', unit: '', order: '' },
        ],
        [
          { n: '当日交易手续费', v: '--', unit: '', order: '' },
          { n: '交收货值变化', v: '--', unit: '', order: '' },
          { n: '货款支出', v: '--', unit: '', order: '' }
          // { n: '当日印花税', v: '--', unit: '', order: '' },
        ],
        [
          { n: '当日违约金', v: '--', unit: '', order: '' },
          // { n: '当日交收手续费', v: '--', unit: '', order: '' },
          { n: '', v: '--', unit: '', order: '' },
          { n: '', v: '--', unit: '', order: '' }
        ]
      ],
      mineAsset: {
        accountId: null,
        avilibleMargin: 0,
        balance: 0,
        buyFunds: 0,
        canBeMargin: 0,
        canOutMoney: 0,
        closePl: 0,
        createTime: null,
        deliveryClosePl: 0,
        deliveryFee: 0,
        deliveryMargin: 0,
        firmId: 76034,
        floatPl: 0,
        frozenFunds: 0,
        holdFloatPl: 0,
        inGold: 0,
        lastBalance: 0,
        lastDeliveryMargin: 0,
        lastHoldMargin: 0,
        lastHoldPl: 0,
        lastOweMoney: 0,
        lastRight: 0,
        marketId: 28,
        marketInGold: 0,
        marketOutGold: 0,
        occupyMargin: 0,
        orderHoldMargin: 0,
        outGold: 0,
        oweMoney: 0,
        procedureFee: 0,
        profit: 0,
        right: 0,
        risk: 0,
        sellFunds: 0,
        stampFee: 0,
        swapsFee: 0,
        symbolId: null,
        transferClosePl: 0,
        updateTime: null,
        wyFunds: 0
      }
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'marketDetails', 'RiskRightGetter', 'holdPlSumGetter', 'h_avilibleMargin'])
  },
  // watch: {
  //   myassetDataGetter() {
  //     this.initData()
  //   }
  // },
  mounted() {
    this.queryTradeClosepl()
    // this.initData()
  },
  methods: {
    // 查询当前交易id
    async queryTradeClosepl() {
      if (
        sessionStorage.getItem('sessionStr') &&
        sessionStorage.getItem('userId')
      ) {
        http.postFront(protocol.param_queryTradeClosepl).then(async(response) => {
          const { code, value } = response.data
          if (Number(code) === 0) {
            if (value && value.mineAsset) {
              this.mineAsset = value.mineAsset
            } else {
              this.mineAsset = {
                accountId: null,
                avilibleMargin: 0,
                balance: 0,
                buyFunds: 0,
                canBeMargin: 0,
                canOutMoney: 0,
                closePl: 0,
                createTime: null,
                deliveryClosePl: 0,
                deliveryFee: 0,
                deliveryMargin: 0,
                firmId: 76034,
                floatPl: 0,
                frozenFunds: 0,
                holdFloatPl: 0,
                inGold: 0,
                lastBalance: 0,
                lastDeliveryMargin: 0,
                lastHoldMargin: 0,
                lastHoldPl: 0,
                lastOweMoney: 0,
                lastRight: 0,
                marketId: 28,
                marketInGold: 0,
                marketOutGold: 0,
                occupyMargin: 0,
                orderHoldMargin: 0,
                outGold: 0,
                oweMoney: 0,
                procedureFee: 0,
                profit: 0,
                right: 0,
                risk: 0,
                sellFunds: 0,
                stampFee: 0,
                swapsFee: 0,
                symbolId: null,
                transferClosePl: 0,
                updateTime: null,
                wyFunds: 0
              }
            }
            this.initData()
          }
        })
      }
    },

    initData() {
      this.tableData = [
        [
          { n: '当前可用资金', v: this.h_avilibleMargin ? Number(this.h_avilibleMargin).toFixed(2) : '--', unit: '', order: '' },
          { n: '当前余额', v: this.mineAsset.balance, unit: '', order: '' },
          { n: '当前权益', v: this.RiskRightGetter.right, unit: '', order: '' }

        ],
        [
          { n: '划入资金', v: this.mineAsset.marketInGold, unit: '', order: '' },
          { n: '期初余额', v: this.mineAsset.lastBalance, unit: '', order: '' },
          { n: '期初权益', v: this.mineAsset.lastRight, unit: '', order: '' }
        ],
        [
          { n: '划出资金', v: this.mineAsset.marketOutGold, unit: '', order: '' },
          { n: '风险率', v: this.RiskRightGetter.risk ? this.RiskRightGetter.risk : '--', unit: '%', order: '' },
          { n: '挂单冻结资金', v: this.mineAsset.orderHoldMargin, unit: '', order: '' }
        ],
        [
          { n: '转让盈亏', v: this.mineAsset.transferClosePl, unit: '', order: '' },
          { n: '货值变化', v: this.holdPlSumGetter.holdPl, unit: '', order: '' },
          // { n: '有效货值变化', v: this.holdPlSumGetter.holdPl > 0 ? 0 : this.holdPlSumGetter.holdPl, unit: '', order: '' }
          { n: '当日交收手续费', v: this.mineAsset.deliveryFee, unit: '', order: '' },
        ],
        [
          { n: '当日订金', v: this.mineAsset.occupyMargin, unit: '', order: '' },
          { n: '交收担保金', v: this.mineAsset.deliveryMargin, unit: '', order: '' },
          { n: '货款收入', v: this.mineAsset.sellFunds, unit: '', order: '' }
          // { n: '上日订金', v: this.mineAsset.lastHoldMargin, unit: '', order: '' },

        ],
        [
          // { n: '上日有效货值变化', v: this.mineAsset.lastHoldPl > 0 ? 0 : this.mineAsset.lastHoldPl, unit: '', order: '' },
          { n: '当日交易手续费', v: this.mineAsset.procedureFee, unit: '', order: '' },
          { n: '交收货值变化', v: this.mineAsset.deliveryClosePl, unit: '', order: '' },
          { n: '货款支出', v: this.mineAsset.buyFunds, unit: '', order: '' }

        ],
        [
          { n: '当日违约金', v: this.mineAsset.wyFunds, unit: '', order: '' },
          // { n: '当日交收手续费', v: this.mineAsset.deliveryFee, unit: '', order: '' },
          { n: '', v: '', unit: '', order: '' },
          { n: '', v: '', unit: '', order: '' }
        ]
      ]
    }
  }
}
</script>
<style scoped lang="scss">
#transcc_new_tab_myAssetsNew{
  display: flex;
  width: 100%;
  // flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  // align-content: flex-start;
  .as_row{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    .as_col{
      flex: auto;
      display: flex;
      flex-direction: row;
      flex: 1;
      div{
        flex-basis: 0;
        padding: 0 10px;
        height: 30px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 14px;
        border: 0.5px solid #2B2B2B;
      }
      .as_col_n{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex: 1
      }
      .as_col_v{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1
      }
    }
  }
}
</style>
